
import './App.css';
import { Navbar } from './Components/Navbar/Navbar';
import { BrowserRouter ,Routes , Route } from 'react-router-dom';
import Shop from './Pages/Shop';
import ShopCategory from './Pages/ShopCategory';

import Cart from './Pages/Cart';
import LoginSignup from './Pages/LoginSignup';
import Product from './Pages/Product';
import Footer from './Components/Footer/Footer';
import men_banner from './Components/Assets/Frontend_Assets/banner_mens.png'
import women_banner from './Components/Assets/Frontend_Assets/banner_women.png'
import kids_banner from './Components/Assets/Frontend_Assets/banner_kids.png'
import AddressForm from './Pages/AddressForm';
import OrderSuccess from './Pages/OrderSuccess';
import MyOrders from './Pages/MyOrders';
import OrderDetail from './Pages/OrderDetail';
import Faq from './Pages/Faq';
import ContactUs from './Pages/ContactUs';
import BlogPage from './Pages/BlogPage';
import AboutUs from './Pages/AboutUs';
import PrivacyPolicy from './Pages/PrivacyPolicy';
import TermsConditions from './Pages/TermsConditions';
function App() {
  return (
    <div> 
      <BrowserRouter>
        <Navbar/>
        <Routes>
          <Route path='/' element={<Shop />}></Route>
          <Route path='/men' element={<ShopCategory banner = {men_banner} category = "men" />} />
          <Route path='/women' element={<ShopCategory banner = {women_banner} category = "women" />} />
          <Route path='/kids' element={<ShopCategory banner = {kids_banner} category = "kids" />} />
          <Route path="/category/:main/:type/:fabric" element={<ShopCategory />}/>
          <Route path="/category/:main/:type" element={<ShopCategory />} />
          <Route path="/category/:main/:type/:fabric" element={<ShopCategory />} />
           <Route path="/results/category/:main/:sizeType" element={<ShopCategory />} />
          <Route  path='/product' element={<Product />}>
            <Route path=':productId' element={<Product />} />
          </Route>
          <Route  path='/cart' element={<Cart />} />
           <Route path="/checkout/address" element={<AddressForm />} />
            <Route path="/order-success/:id" element={<OrderSuccess />} />

          <Route  path='/login' element={<LoginSignup />} />
          <Route path="/my-orders" element={<MyOrders />} />
          <Route path="/order/:id" element={<OrderDetail />} />
          <Route path="/ContactUs" element={<ContactUs />} />     
         <Route path="/Blogs" element={<BlogPage />} /> 
          <Route path="/faq" element={<Faq />} />
          <Route path="/about" element={<AboutUs />} />
           <Route path="/privacy-policy" element={<PrivacyPolicy />} />
         <Route path="/terms" element={<TermsConditions />} /> 
        </Routes>
        <Footer />
     </BrowserRouter>
    </div>
  );
}

export default App;
